module.exports = {
      id: "pinterest-square-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-9780240c1c89505db7f372dec3b5867e.svg#pinterest-square",
      toString: function () {
        return this.url;
      }
    }